@if (showSwitch) {
  <div style="display: flex; justify-content: space-between; align-items: center">
    <span style="font-weight: 600">Set persistent attribute to LD</span>
    <ftr-switch [value]="persistentFlagEnabled" (onValueChange)="onPersistentFlagChange($event)"></ftr-switch>
  </div>
}
